import { Tooltip } from "@eudonet/opal";
import { defineComponent, h, onBeforeUnmount, onMounted, ref } from "vue";
export const TruncatedCell = defineComponent({
    name: "TruncatedCell",
    props: {
        text: { type: String, required: true },
        textClass: { type: String, default: "text-sm text-(--text-text-body)" },
    },
    setup(props) {
        const spanRef = ref(null);
        const isTruncated = ref(false);
        let observer = null;
        onMounted(() => {
            if (spanRef.value) {
                observer = new ResizeObserver(() => {
                    if (spanRef.value) {
                        isTruncated.value = spanRef.value.scrollWidth > spanRef.value.offsetWidth;
                    }
                });
                observer.observe(spanRef.value);
            }
        });
        onBeforeUnmount(() => {
            observer?.disconnect();
        });
        return () => h(Tooltip, { text: props.text, disabled: !isTruncated.value, style: "display: block; width: 100%;" }, () => h("span", { ref: spanRef, class: `block truncate ${props.textClass}` }, props.text));
    },
});
